@let configuration = configurationSg();

<div class="atn-space-report-employee-list">
  <atn-ds-widget title="Configuration">
    <div class="atn-space-report-employee-list__configuration">
      <div class="atn-space-report-employee-list__selects">
        <atn-ds-select-single
          label="Format"
          [items]="formatItems"
          [value]="configuration.format"
          [required]="true"
          (valueChange)="formatChangeHandler($event)"
        />
      </div>

      @if (!isStandardUserSg()) {
        <atn-ds-checkbox
          label="Show Salary Information"
          [selected]="configuration.showSalaryInformation"
          (selectedChange)="showSalaryInformationChangeHandler($event)"
        />
      }
    </div>
  </atn-ds-widget>

  <atn-ds-widget title="Filters">
    <div class="atn-space-report-employee-list__filters">
      <atn-ds-section name="Organization">
        <div class="atn-space-report-employee-list__filter-section">
          <atn-space-dimension-filter [plugin]="organizationFilterPlugin" />
        </div>
      </atn-ds-section>
    </div>
  </atn-ds-widget>
</div>
